define.alias("shared/modifiers/wheel-pan", "calendar/modifiers/wheel-pan");